import { render, staticRenderFns } from "./FormControlRegion.vue?vue&type=template&id=4385290a"
import script from "./FormControlRegion.vue?vue&type=script&lang=js"
export * from "./FormControlRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4385290a')) {
      api.createRecord('4385290a', component.options)
    } else {
      api.reload('4385290a', component.options)
    }
    module.hot.accept("./FormControlRegion.vue?vue&type=template&id=4385290a", function () {
      api.rerender('4385290a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/Control/FormControlRegion.vue"
export default component.exports